import { WarningHint } from './WarningHint'

interface ICodeValueProps {
  value: string | null
  missingWarning?: { label: string; message: string }
}

export const CodeValue = ({ value, missingWarning }: ICodeValueProps) =>
  value ? (
    <span className='text-gray-800 fw-semibold'>{value}</span>
  ) : (
    <span className='d-inline-flex align-items-center gap-2'>
      <span className='badge badge-light-warning'>Sin código</span>
      {missingWarning && <WarningHint {...missingWarning} />}
    </span>
  )

interface IEditButtonProps {
  ariaLabel: string
  onClick: () => void
}

export const EditButton = ({ ariaLabel, onClick }: IEditButtonProps) => (
  <button
    type='button'
    className='btn btn-sm btn-icon btn-active-light-primary'
    aria-label={ariaLabel}
    title='Editar'
    onClick={onClick}
  >
    <i className='bi bi-pencil fs-6' />
  </button>
)

interface ICancelButtonProps {
  disabled: boolean
  onClick: () => void
}

export const CancelButton = ({ disabled, onClick }: ICancelButtonProps) => (
  <button type='button' className='btn btn-sm btn-light' disabled={disabled} onClick={onClick}>
    Cancelar
  </button>
)
